import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: string;
  english_title: string;
  malay_title: string;
  mandarin_title: string;
  description_english: string;
  description_malay: string;
  description_mandarin: string;
  redirect_url_english: string;
  redirect_url_malay: string;
  redirect_url_mandarin: string;
  image: string;
  published: boolean;
}

// edit api call
const fetchHelpContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/flight-information-card/${id}`);

  return response?.data[0];
};

const useHelpContentDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["HelpContentDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchHelpContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useHelpContentDocumentDetails };
